// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASEAPI_KEY,
  authDomain: process.env.REACT_APP_FIREBASEAUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASEPROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASESTORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASESENDER_ID,
  appId: process.env.REACT_APP_FIREBASEAPP_ID,
  measurementId: process.env.REACT_APP_FIREBASEMEASUREMENT_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const storage = getStorage(app);
export const db = getFirestore();
export default app;
